import React from 'react';
import { motion } from 'framer-motion';
import { Frown, AlertCircle, TrendingDown, Quote } from 'lucide-react';
export function PainPointsSection() {
  const pains = [{
    icon: <Frown className="w-8 h-8 text-coral-500" data-id="element-76" />,
    text: 'Sientes ansiedad cada vez que tienes que revisar tu cuenta bancaria.'
  }, {
    icon: <TrendingDown className="w-8 h-8 text-terracotta-500" data-id="element-77" />,
    text: 'El dinero entra y sale, y al final del mes no sabes en qué se fue.'
  }, {
    icon: <AlertCircle className="w-8 h-8 text-peach-600" data-id="element-78" />,
    text: "Quieres ahorrar pero siempre surge un 'imprevisto' que te deja en cero."
  }];
  return <section className="py-20 md:py-28 bg-white relative overflow-hidden px-4" data-id="element-79">
      {/* Background texture */}
      <div className="absolute inset-0 bg-paper opacity-50 pointer-events-none" data-id="element-80"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-81">
        <div className="text-center mb-20" data-id="element-82">
          <h2 className="text-3xl md:text-5xl font-bold text-warm-gray mb-6" data-id="element-83">
            💭 ¿Te sientes identificada? 💔
          </h2>
          <div className="w-32 h-2 bg-peach-300 mx-auto rounded-full opacity-60" data-id="element-84"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 md:gap-10" data-id="element-85">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.5
        }} className="bg-cream-50 rounded-[2rem] p-8 border border-peach-100 text-center hover:shadow-warm-lg transition-all duration-300 group" data-id="element-86">
              <p className="text-lg text-warm-800 font-medium leading-relaxed" data-id="element-87">
                "{pain.text}"
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mt-20 text-center max-w-3xl mx-auto" data-id="element-88"></motion.div>
      </div>
    </section>;
}